export type SortBy =
    | 'name-asc'
    | 'lastMeasurement-desc'
    | 'lastMeasurement-asc'
    | 'weight-desc'
    | 'weight-asc'
    | 'lice-desc'
    | 'lice-asc';

export const DEFAULT_SORT_BY: SortBy = 'name-asc';

export interface SortOption {
    value: SortBy;
    labelKey: string;
}

export const SORT_OPTIONS: SortOption[] = [
    { value: 'name-asc', labelKey: 'molecules.sortByDropdown.options.nameAsc' },
    {
        value: 'lastMeasurement-desc',
        labelKey: 'molecules.sortByDropdown.options.lastMeasurementDesc',
    },
    {
        value: 'lastMeasurement-asc',
        labelKey: 'molecules.sortByDropdown.options.lastMeasurementAsc',
    },
    { value: 'weight-desc', labelKey: 'molecules.sortByDropdown.options.weightDesc' },
    { value: 'weight-asc', labelKey: 'molecules.sortByDropdown.options.weightAsc' },
    { value: 'lice-desc', labelKey: 'molecules.sortByDropdown.options.liceDesc' },
    { value: 'lice-asc', labelKey: 'molecules.sortByDropdown.options.liceAsc' },
];
